import { render } from "./SlotPageVisual.vue?vue&type=template&id=367f4d3e"
import script from "./SlotPageVisual.vue?vue&type=script&lang=js"
export * from "./SlotPageVisual.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__